module.exports = __webpack_public_path__ + "img/irondogstudio.153a0211.svg";